import api from "./api";

function toParams({ page, pageSize, search, sortBy, sortOrder, ...rest } = {}) {
    const params = { ...rest };
    if (page) params.page = page;
    if (pageSize) params.page_size = pageSize;
    if (search) params.search = search;
    if (sortBy) params.sort_by = sortBy;
    if (sortOrder) params.sort_order = sortOrder;
    return params;
}

export const customersService = {
    async list(query = {}) {
        const { data } = await api.get("/customers", { params: toParams(query) });
        return data;
    },
    async get(id) {
        const { data } = await api.get(`/customers/${id}`);
        return data;
    },
    async create(payload) {
        const { data } = await api.post("/customers", payload);
        return data;
    },
    async update(id, payload) {
        const { data } = await api.patch(`/customers/${id}`, payload);
        return data;
    },
    async remove(id) {
        await api.delete(`/customers/${id}`);
    },
};
